export default __webpack_public_path__ + "static/media/2020 (2).a0869234.JPG";